import {inject, injectable} from 'inversify';

import {CreateDiaryEntryCmd} from '../ports/CreateDiaryEntry/CreateDiaryEntry.cmd';

@injectable()
export class CreateDiaryEntryUseCase {
  constructor(
    @inject(CreateDiaryEntryCmd)
    private readonly cmd: CreateDiaryEntryCmd,
  ) {}

  async exec(
    props: CreateDiaryEntryUseCase.Props,
  ): Promise<CreateDiaryEntryUseCase.Response> {
    return this.cmd.exec(props);
  }
}

export namespace CreateDiaryEntryUseCase {
  export type Props = CreateDiaryEntryCmd.Props;
  export type Response = CreateDiaryEntryCmd.Response;
}
